export const PRODUCT_ACTIVE_PACKAGE_TOOLTIP = "Product is used in active Packages";

export function readHasActiveOffering(dto: any): boolean | undefined {
  if (dto == null || typeof dto !== "object") return undefined;
  const raw =
    dto.hasActiveOffering ??
    dto.HasActiveOffering ??
    dto.hasActiveOfferingOnPricelist ??
    dto.HasActiveOfferingOnPricelist;
  return typeof raw === "boolean" ? raw : undefined;
}

export function readIsUsedInActivePackage(dto: any): boolean | undefined {
  if (dto == null || typeof dto !== "object") return undefined;
  const raw =
    dto.isUsedInActivePackage ??
    dto.IsUsedInActivePackage ??
    dto.hasActivePackage ??
    dto.HasActivePackage;
  return typeof raw === "boolean" ? raw : undefined;
}

export function isProductActiveDeactivationLocked(
  product: { isUsedInActivePackage?: boolean; active?: boolean; id?: number | string } | null | undefined,
  options?: { formDisabled?: boolean }
): boolean {
  if (options?.formDisabled) return false;
  const id = Number(product?.id ?? 0);
  if (id <= 0) return false;
  if (product?.isUsedInActivePackage !== true) return false;
  return product?.active !== false;
}